import { render } from "./InputWithLabel.vue?vue&type=template&id=9538bc80&scoped=true"
import script from "./InputWithLabel.vue?vue&type=script&lang=ts"
export * from "./InputWithLabel.vue?vue&type=script&lang=ts"

import "./InputWithLabel.vue?vue&type=style&index=0&id=9538bc80&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9538bc80"

export default script